import { render, staticRenderFns } from "./OrganisationSelector.vue?vue&type=template&id=899a903e"
import script from "./OrganisationSelector.vue?vue&type=script&lang=ts"
export * from "./OrganisationSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports